(function(angular) {

    var _provider;
    var _endpointModel;
    var _userService = {};
    var _dispositionService;
    var _channelId;
    var _cm;
    var _log;
    var _channelUsersMap;
    var _users = [];
    var _rootScope;
    var _activeDispositionEP;

    function findIndexOfUser(user) {
        return _users.findIndex((val) => {
            return val.userName === user;
        });
    }

    function findIndexOfEndpoint(user, epId) {
        return user.endpoints.findIndex((ep) => {
            return ep.id === epId;
        });
    }

    function sameUserDiffEndpoint(ep1, ep2) {
        return ep1.userName === ep2.userName && ep1.id !== ep2.id
    }

    function addUserToCollection(user) {
        var ui = new _userService.UserInfo(user);

        try {
            ui.endpoints = Array.from(_channelUsersMap.get(user).values());
            for (let ep of ui.endpoints) {
                ui.updateUserInfo(ep);
            }

            _users.push(ui);
        } catch(exc) {
            _log.error('userService error:', exc);
        }

        return ui;
    }

    function updateMyDisposition(ep) {
        var _myEndpoint = _endpointModel.getMyEndpoint();

        if (!ep.Self && (_myEndpoint && ep.userName === _myEndpoint.userName)) {
            if (_myEndpoint.disposition !== ep.disposition) {
                _dispositionService.setDisposition(_myEndpoint.id, ep.disposition);
            }
        }

    }

    function isPrivateTextEnabled(endpoint) {
        return !endpoint.Self && endpoint.userName !== _endpointModel.getMyEndpoint().userName; // && endpoint.privateTxtEnabled === 'true';
    }

    (function(module) {

        function isBusy(endpoint) {
            return endpoint.disposition && endpoint.disposition.match(/^busy$/i) !== null;
        }

        function isOnPhone(endpoint) {
            return endpoint.disposition && endpoint.disposition.match(/^phone$/i) !== null;
        }

        function isAway(endpoint) {
            return endpoint.disposition && endpoint.disposition.match(/^away$/i) !== null;
        }

        function privateCallEnabled(endpoint) {

                if (!endpoint.Self && endpoint.name !== _endpointModel.getMyEndpoint().name && endpoint.callAlias) {
                    return true;
                }

            return false;
        }

        class UserInfo {

            constructor(userName) {
                this.userName = userName;
                this.displayName = '';
                this.endpoints = [];
                this._endpointIndex = 0;
                this.sharingLocation = false;
                this.privateCallEnabled = false;
                this.privateTextEnabled = false;
                this.callAlias = '';
                this.self = false;
                this.callActive = false;
            }

            get endpointIndex() {
                return this._endpointIndex;
            }

            set endpointIndex(val) {
                if (val > (this.endpoints.length - 1)) {
                    this._endpointIndex = 0;
                } else {
                    this._endpointIndex = val;
                }
            }

            get name() {
                return this.getCurrentEndpoint().name;
            }

            endpointExists(endpointId) {
                return findIndexOfEndpoint(this, endpointId) > -1;
            }

            addEndpoint(ep) {
                this.endpoints.push(ep);
                this.updateUserInfo(ep);
            }

            deleteEndpoint(endpointId) {
                var epIndex = findIndexOfEndpoint(this, endpointId);
                if(epIndex > -1) {
                    var deleted = this.endpoints.splice(epIndex, 1);
                    var _myEndpoint = _endpointModel.getMyEndpoint();
                    this.endpointIndex = 0;

                    if (deleted.length > 0) {
                        var sharingEP = this.endpoints.find((ep) => {
                            return ep.privateTxtEnabled && ep.privateTxtEnabled === 'true' && ep.userName !== _myEndpoint.userName;
                        });
                        if (!sharingEP) {

                            this.privateTextEnabled = false;
                            _rootScope.$broadcast('userService.privateTextEnabled', this, false);
                        }
                    }
                }
            }

            updateUserInfo(ep) {
                var _myEndpoint = _endpointModel.getMyEndpoint();

                let indx = findIndexOfEndpoint(this, ep.id);

                if (indx > -1) {
                    this.endpoints[indx] = ep;
                }

                if (ep.userName === _myEndpoint.userName) {
                    this.self = true;
                }

                var _privateCallEnabled = !isBusy(ep) && !isOnPhone(ep) && ( this.privateCallEnabled || privateCallEnabled(ep) );

                if (ep.location) {
                    this.sharingLocation = true;
                }

                this.displayName = this.displayName || ep.name;

                this.callAlias = ep.callAlias;

                if (!this.callActive) {
                    this.privateCallEnabled = _privateCallEnabled;
                }

                if (isPrivateTextEnabled(ep)) {
                    if (!this.privateTextEnabled) {
                        this.privateTextEnabled = true;
                        _rootScope.$broadcast('userService.privateTextEnabled', this, true);
                    }
                }

                // Disposition

                var _disposition = '';

                if (ep.disposition) {
                    _disposition = ep.disposition.toLowerCase();
                }

                switch (_disposition) {
                    case "ready":
                        // When first logging in, endpoint disposition is Ready. But we don't know if the user
                        // actually is in a Ready state. We need to look at all other endpoints of this user
                        // and see if they are on the phone or busy
                        if(ep.Self) {
                            if (!_activeDispositionEP) {
                                _activeDispositionEP = this.endpoints.find(isOnPhone);
                            }

                            if (_activeDispositionEP && _activeDispositionEP.id !== ep.id) { // User not 'ready'
                                updateMyDisposition(_activeDispositionEP);
                                _disposition = ep.disposition.toLowerCase();
                            }
                        }

                        if(_activeDispositionEP && _activeDispositionEP.id === ep.id) {
                            updateMyDisposition(ep);
                            _activeDispositionEP = void 0;
                        }

                        if(!_activeDispositionEP || !sameUserDiffEndpoint(_activeDispositionEP, ep)) {
                            this.disposition = _disposition;
                        }

                        break;
                    case "phone":
                        if(!_activeDispositionEP && sameUserDiffEndpoint(_myEndpoint, ep) && !this.callActive) {
                            _activeDispositionEP = ep;
                        }

                        updateMyDisposition(ep);
                        this.disposition = _disposition;

                        break;
                    case "busy":
                    case "away":

                        updateMyDisposition(ep);
                        this.disposition = _disposition;

                        break;
                    case "idle":
                        let allIdle = true;

                        for (var x = 0; x < this.endpoints.length; x++) {
                            if (this.endpoints[x].disposition !== ep.disposition) {
                                allIdle = false;
                                break;
                            }
                        }

                        if (allIdle) {
                            this.disposition = _disposition;
                        }
                        break;
                }
            }

            getCurrentEndpoint() {
                return this.endpoints[this.endpointIndex];
            }

            getNextEndpoint() {
                this.endpointIndex++;
                return this.getCurrentEndpoint();
            }

            get location() {
                if (!this.sharingLocation) return void 0;

                let _curEndpoint = this.getCurrentEndpoint();

                if(_curEndpoint && _curEndpoint.location) {
                    return _curEndpoint.location;
                } else {
                    if(!_curEndpoint) {
                        _log.warn("Current Endpoint is undefined, this shouldn't happen");
                    }
                    return this.getNextLocation();
                }
            }
            getNextLocation() {
                var startIndex = ++this.endpointIndex;
                var ep = this.getCurrentEndpoint();
                while (ep && !ep.location) {
                    ep = this.getNextEndpoint();

                    if (this.endpoints.length === 1 || this.endpointIndex === startIndex) {
                        _log.warn("user is sharingLocation but no endpoint has location data");
                        this.sharingLocation = false;
                        return void 0;
                    }
                }

                if(ep) {
                    return ep.location;
                } else {
                    _log.warn("ep is undefined, this should never happen");
                    return void 0;
                }
            }
        }

        module.UserInfo = UserInfo;
    })(_userService);

    class UserService {
        constructor($rootScope, $log, wtcpjsClientProviderService, channelModel, endpointModel, dispositionService) {
            var unbindUserJoined = null;
            _cm = channelModel;
            _log = $log;
            _channelUsersMap = new Map();
            _dispositionService = dispositionService;
            _endpointModel = endpointModel;
            _rootScope = $rootScope;
            _provider = wtcpjsClientProviderService;

            function unbindExistingUserJoinedHandler() {
                if(unbindUserJoined) {
                    unbindUserJoined();
                }
            }

            function clearUsers() {
                _users.length = 0;
                _channelUsersMap.clear();
                _channelId = 0;
                unbindExistingUserJoinedHandler();
            }

            function loadUsers() {
                _users.length = 0;
                _channelId = channelModel.getSelectedChannel().id;
                _channelUsersMap = endpointModel.getChannelUsers(_channelId);

                for (let user of _channelUsersMap.keys()) {
                    addUserToCollection(user);
                }

                unbindExistingUserJoinedHandler();
                unbindUserJoined = $rootScope.$on('endpointModel.userJoined', function(event, channelId, endpoint) {
                    var selectedChannel = _cm.getSelectedChannel();
                    //var isPrivateCallFilter = endpoint.filterIds && endpoint.filterIds.includes(_provider.filterTypes.privateCallChannelFilter);
                    if( selectedChannel && channelId === selectedChannel.id ) {
                        $rootScope.$broadcast('userService.userJoined', addUserToCollection(endpoint.userName));
                    }
                });

                $rootScope.$broadcast('userService.usersLoaded', _users);
            }

            function isSelectedChannel(channelId) {
                var selectedChannel = channelModel.getSelectedChannel();

                return selectedChannel && channelId === selectedChannel.id;
            }

            function userOnSelectedChannel(channelId) {
                let _selectedChannel = _cm.getSelectedChannel();

                if(!_selectedChannel) {
                    return false;
                }

                if (channelId === 0) {
                    return _selectedChannel.id < 0;
                } else {
                    return channelId === _selectedChannel.id;
                }
            }

            var unbindUserLeft = $rootScope.$on('endpointModel.userLeft', (event, channelId, userName) => {
                if(userOnSelectedChannel(channelId)) {
                    var userIndex = findIndexOfUser(userName);

                    if (userIndex > -1) {
                        $rootScope.$broadcast('userService.userLeft', _users.splice(userIndex, 1)[0], channelId);
                    }
                }
            });

            var unbindEndpointLogout = $rootScope.$on('ConnectionService.logout', () => {
                clearUsers();
            });

            var unbindEndpointsLoaded = $rootScope.$on('endpointModel.endpointsLoaded', () => {
                loadUsers();
            });

            var unbindPresenceUpdated = $rootScope.$on('endpointModel.presenceUpdated', (event, channelEndpoints, channelId, endpointId, userName) => {

                if (isSelectedChannel(channelId)){

                    var userIndex = findIndexOfUser(userName);

                    if(userIndex > -1) {
                        var user = _users[userIndex];

                        if (channelEndpoints.has(endpointId)) {
                            var updatedEP = endpointModel.getEndpoint(endpointId);

                            _channelUsersMap.get(userName).set(endpointId, updatedEP);
                            if (user.endpointExists(endpointId)) {
                                user.updateUserInfo(updatedEP);
                            } else {
                                user.addEndpoint(updatedEP);
                            }

                            $rootScope.$broadcast('userService.userUpdated', _users[userIndex]);
                        } else { // Endpoint has left
                            user.deleteEndpoint(endpointId);
                        }
                    }
                }
            });

            var unbindCallConnected = $rootScope.$on('privateCallService.callConnected', (e, channel) => {
                var userIndex = findIndexOfUser(channel.participantId);

                if(userIndex > -1) {
                    let user = _users[userIndex];
                    user.callActive = true;
                    _activeDispositionEP = _endpointModel.getMyEndpoint();
                    user.privateCallEnabled = false;
                }
            });

            var unbindReconnecting = $rootScope.$on('isReconnecting', (e, reconnecting) => {
                if(reconnecting) {
                    _activeDispositionEP = null;
                }
            });

            $rootScope.$on('destroy', function() {
                unbindExistingUserJoinedHandler();
                unbindReconnecting();
                unbindUserLeft();
                unbindEndpointsLoaded();
                unbindPresenceUpdated();
                unbindEndpointLogout();
                unbindCallConnected();
            });
        }
        getUsers() {
            return _users;
        }
        getUser(userName) {
            return _users[_users.findIndex((u) => u.userName === userName)];
        }
        get userCount() {
            return _users.length;
        }
    }

    angular
        .module('webcomm')
        .service('userService', [
            '$rootScope',
            '$log',
            'wtcpjsClientProviderService',
            'channelModel',
            'endpointModel',
            'dispositionService',
            UserService
        ]);
})(angular)